import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './ConsentRequestsList.css';
import { sharedLabelsPath } from "../../../reducers/common/localization";
import _ from 'lodash';
import ConsentRequestsCard from '../consentRequestCard/ConsentRequestsCard.container';
import ConsentRequestDetails from '../consentRequestDetails/ConsentRequestDetails.container';
import IconContainer from '../../commonComponents/iconContainer/IconContainer';

class ConsentRequestsList extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isOpenList: true
        }
    }

    componentDidMount() {
        this.props.onMount();
        if (this.listContainer) {
            this.listContainer.addEventListener('scroll', this.onScroll);
        }
    }

    componentWillUnmount() {
        this.props.onUnmount();
        if (this.listContainer) {
            this.listContainer.removeEventListener('scroll', this.onScroll);
        }
    }

    componentDidUpdate(prevProps) {
        if (this.props.departmentId !== prevProps.departmentId) {
            this.props.onGetConsentRequests();
        }
    }

    onScroll = (e) => {
        let elem = e.target;
        if (this.props.isLoadNextPageAvailable && !this.props.loading && elem.scrollTop + 10 > elem.scrollHeight - elem.clientHeight) {
            this.props.onGetConsentRequestsNextPage();
        }
    };

    render() {
        return (
            <div className="consent-requests-list-container ">
                {this.renderListToggler()}
                <div className="consent-requests-list-content-container ">
                    <div 
                        className={"consent-requests-cards-list-container " + (this.state.isOpenList ? "list-open" : "")}
                        ref={(elem) => { this.listContainer = elem }}
                    >
                        {this.renderContent()}
                    </div>
                    <div className="consent-requests-details-container">
                        <ConsentRequestDetails />
                    </div>
                </div>
            </div>
        );
    }

    renderContent = () => {
        if (this.props.loading && (_.isNil(this.props.data) || this.props.data.length === 0)) {
            return (
                <div className="consent-requests-status-message-container">
                    <h6>{_.get(this.props.translation, sharedLabelsPath.fetching_message)}</h6>
                </div>
            );
        }

        if (!_.isNil(this.props.data) && this.props.data.length === 0) {
            return (
                <div className="consent-requests-status-message-container">
                    <h6>{_.get(this.props.translation, "consents.no_data_label")}</h6>
                </div>
            );
        }

        if (!_.isNil(this.props.data)){
            return [this.renderCards(), this.props.loading ? <h6 key="fetching-message" className="text-center">{_.get(this.props.translation, sharedLabelsPath.fetching_message)}</h6> :
                this.props.isLoadNextPageAvailable ? <div key="empty-div" className="consent-requests-cards-list-empty-div"></div> : null
            ];
        }
    }

    renderCards = () => {
        return _.map(this.props.data, (elem) => {
            return (
                <ConsentRequestsCard key={elem.id} data={elem} id={elem.id} onClick={this.toggleList}/>
            );
        });
    };

    renderListToggler = () => {
        return (
            <div onClick={this.toggleList} className={"toggle-consents-list-button " + (this.state.isOpenList ? "button-open" : "")}>
                <IconContainer className="toggle-consents-list-icon" icon="arrow_back"/>
                <h6>{_.get(this.props.translation, "consents." + (this.state.isOpenList ? "hide_consents_list_label" : "show_consents_list_label"))}</h6>
            </div>
        )
    };

    onFilterStatusChange = (e) => {
        this.props.onSetFilter(e.target.value);
    };

    toggleList = () => {
        this.setState({ isOpenList: !this.state.isOpenList });
    };
}

ConsentRequestsList.propTypes = {
    data: PropTypes.array,
    loading: PropTypes.bool,
    departmentId: PropTypes.string,
    isLoadNextPageAvailable: PropTypes.bool,
    translation: PropTypes.object.isRequired,
    onMount: PropTypes.func.isRequired,
    onUnmount: PropTypes.func.isRequired,
    onGetConsentRequests: PropTypes.func.isRequired,
    onGetConsentRequestsNextPage: PropTypes.func.isRequired,
};

export default ConsentRequestsList;



// WEBPACK FOOTER //
// ./src/components/organizationConsentManagement/consentRequestsList/ConsentRequestsList.js